export default {
  SET_TASK_TRAINING: 'SET_TASK_TRAINING',
  UPDATE_TASK_TRAINING: 'UPDATE_TASK_TRAINING',
  SET_MY_TASK_RESPONSES: 'SET_MY_TASK_RESPONSES',
  ADD_TASK_RESPONSES: 'ADD_TASK_RESPONSES',
  SET_TASK_RESPONSE_ACK: 'SET_TASK_RESPONSE_ACK',
  SET_TASK_RESPONSE_STATUS: 'SET_TASK_RESPONSE_STATUS',
  REJECT_TASK_RESPONSE: 'REJECT_TASK_RESPONSE',
  UPDATE_TASK_RESPONSE: 'UPDATE_TASK_RESPONSE'
}
